import Vue from 'vue';

import {
    Tabbar,
    TabbarItem,
    Tabs,
    Tab,
    ActionSheet,
    Sticky,
    Form,
    Button,
    Cell,
    CellGroup,
    Image as VanImage,
    Col,
    Row,
    Field,
    Cascader,
    Checkbox,
    CheckboxGroup,
    RadioGroup,
    Radio,
    Rate,
    Search,
    Switch,
    DropdownMenu,
    DropdownItem,
    List,
    PullRefresh,
    Badge,
    Empty,
    Skeleton,
    Grid,
    GridItem,
    NavBar,
    Icon,
    DatetimePicker,
    Stepper,
    NumberKeyboard,

    Overlay,
    Area,
    Toast,
    Dialog,
    Popup,
    Loading,
    ImagePreview,
    Swipe,
    SwipeItem,
    Lazyload,
    Picker
} from 'vant';

Vue.use(Toast);
Vue.use(Dialog);
Vue.use(ImagePreview);
Vue.use(Lazyload);
Vue.use(Picker);
Vue.use(Overlay);

Vue.component(Tabbar.name, Tabbar);
Vue.component(TabbarItem.name, TabbarItem);
Vue.component(Tabs.name, Tabs);
Vue.component(Tab.name, Tab);
Vue.component(ActionSheet.name, ActionSheet);
Vue.component(Sticky.name, Sticky);

Vue.component(Button.name, Button);
Vue.component(Form.name, Form);
Vue.component(Field.name, Field);
Vue.component(Cell.name, Cell);
Vue.component(CellGroup.name, CellGroup);
Vue.component(VanImage.name, VanImage);
Vue.component(Col.name, Col);
Vue.component(Row.name, Row);
Vue.component(Cascader.name, Cascader);
Vue.component(Checkbox.name, Checkbox);
Vue.component(CheckboxGroup.name, CheckboxGroup);
Vue.component(RadioGroup.name, RadioGroup);
Vue.component(Radio.name, Radio);
Vue.component(Rate.name, Rate);
Vue.component(Search.name, Search);
Vue.component(Switch.name, Switch);
Vue.component(DropdownItem.name, DropdownItem);
Vue.component(DropdownMenu.name, DropdownMenu);
Vue.component(List.name, List);
Vue.component(PullRefresh.name, PullRefresh);
Vue.component(Badge.name, Badge);
Vue.component(Empty.name, Empty);
Vue.component(Skeleton.name, Skeleton);
Vue.component(Popup.name, Popup);
Vue.component(Grid.name, Grid);
Vue.component(GridItem.name, GridItem);
Vue.component(NavBar.name, NavBar);
Vue.component(Icon.name, Icon);
Vue.component(DatetimePicker.name, DatetimePicker);
Vue.component(Stepper.name, Stepper);
Vue.component(NumberKeyboard.name, NumberKeyboard);
Vue.component(Area.name, Area);
Vue.component(Loading.name, Loading);
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);


// WEBPACK FOOTER //
// ./src/vant.js